import angular from 'angular';
import tooltipDesktopComponent from './tooltipDesktop.component';

let tooltipDesktopModule = angular.module('tooltipDesktop', [
])

.component('tooltipDesktop', tooltipDesktopComponent)

.name;

export default tooltipDesktopModule;



// WEBPACK FOOTER //
// ./client/app/components/tooltipDesktop/tooltipDesktop.js